'use client'

import { usePathname } from 'next/navigation'
import { useMemo, type ReactNode } from 'react'
import cls from 'classnames'

import { NavbarComponent } from './navbar'

type Props = { children: ReactNode }

export function LayoutContainer({ children }: Props) {
  // __STATE's
  const pathname = usePathname()
  const protectedPage = useMemo(() => pathname !== '/', [pathname])

  // __RENDER
  return (
    <div className='ui--app-container'>
      <video className='bg-wave fixed bottom-0 w-screen mix-blend-screen brightness-50' autoPlay playsInline muted loop>
        <source src='/static/media/ww-bg-wave.mp4' type='video/mp4' />
      </video>

      <main className={cls('ui--router-view', { 'logged-in': protectedPage })}>
        {protectedPage && <NavbarComponent />}
        {children}
      </main>
    </div>
  )
}
